import { render, staticRenderFns } from "./MyQuizzesDeleteElementsHint.vue?vue&type=template&id=7b35c313&scoped=true&"
import script from "./MyQuizzesDeleteElementsHint.vue?vue&type=script&lang=js&"
export * from "./MyQuizzesDeleteElementsHint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b35c313",
  null
  
)

export default component.exports